const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export const sortByPropertyWithOrder = <T>(
  array: T[],
  propertyName: string,
  order: boolean,
) => {
  return [...array].sort((a, b) => {
    return order
      ? collator.compare((b as any)[propertyName], (a as any)[propertyName])
      : collator.compare((a as any)[propertyName], (b as any)[propertyName]);
  });
};
